import React from 'react';
import { Box } from '@mui/material';
import { DataGridContainer } from '../ScoringTypes/styled';
import { DataGrid } from '@mui/x-data-grid';
import { getTermsColumns } from './utils/termsColumns';
import { Term } from './types/term';
import pallet from '../../layouts/pallet';
import { dataGridSx } from '../common/styled/DataGrid';

interface TermsTableProps {
  terms: Term[];
  isLoading: boolean;
  onEdit: (term: Term) => void;
  onDelete: (term: Term) => void;
}

const TermsTable: React.FC<TermsTableProps> = ({
  terms,
  isLoading,
  onEdit,
  onDelete
}) => {
  const columns = getTermsColumns(onDelete, onEdit);

  return (
    <DataGridContainer>
      <Box sx={{ width: '100%' }}>
        <DataGrid
          rowHeight={50}
          rows={terms}
          columns={columns}
          loading={isLoading}
          disableRowSelectionOnClick
          pageSizeOptions={[5, 10, 25]}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 }
            },
            columns: {
              ...columns,
              columnVisibilityModel: { id: false }
            }
          }}
          sx={{
            ...dataGridSx(pallet),

            '& .MuiDataGrid-virtualScroller': {
              overflowY: 'auto'
            }
          }}
        ></DataGrid>
      </Box>
    </DataGridContainer>
  );
};

export default TermsTable;
